module.exports = __webpack_public_path__ + "menu_1_active.1ccf265e.png";